import { hashKey, useQuery } from '@tanstack/react-query';

import { Customer, RequestFilters } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export interface FetchCustomerProps {
  filters?: RequestFilters;
  page?: number;
  pageSize?: number;
}

interface FetchCustomerData {
  list: Customer[];
  totalCustomers: number;
}

export const useCustomers = (values?: FetchCustomerProps) =>
  useQuery({
    queryKey: ['customers', hashKey([values])],
    queryFn: async (): Promise<FetchCustomerData> => {
      try {
        const { filters, ...otherValues } = values || {};

        const result = await apiClient.customer.retrieveCustomers.mutation({
          body: filters ? values : otherValues,
        });
        const { list, totalCustomers } = (result.body as any)?.data ?? { list: [], totalCustomers: 0 };
        return { list, totalCustomers };
      } catch (error) {
        showErrorToast(error, 'Error fetching the customers!');
      }
    },
    placeholderData: { list: [], totalCustomers: 0 },
  });
